<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" sm="6" md="3" class="px-3 py-0">
        <label>Prestador</label>
        <v-autocomplete
          v-model="formData.prestador_id"
          :items="prestadoresFilter"
          item-value="id"
          item-text="prest_nome"
          label="Selecione"
          multiple
          chips
          outlined
          flat
          solo
          dense
          filled
          :disabled="formData.carteira_id != null || prestadoresFilter.length==1"
          :search-input.sync="searchInput"
        >
          <template v-slot:item="data">
            <v-list-item
              @click="
                toggleAutocomplete(data.item, 'prestador_id');
                updateOperadoras();
              "
              :class="
                formData.prestador_id.includes(data.item.id)
                  ? 'primary--text v-list-item--active'
                  : ''
              "
            >
              <v-list-item-content>
                <v-list-item-title>{{
                  data.item.prest_nome
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="data">
            <v-chip
              v-if="data.index < 2"
              small
              label
              class="ma-1"
              :style="
                formData.prestador_id.length > 1
                  ? 'max-width:28%'
                  : 'max-width:90%'
              "
              >{{ data.item.prest_nome }}</v-chip
            >
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <!-- <v-col class="py-0 px-3" cols="12" sm="6" md="3">
        <legend>Prestador</legend>
        <v-select
          v-model="formData.prestador_id"
          :items="prestadoresFilter"
          item-value="id"
          item-text="prest_nome"
          :menu-props="{ bottom: true, offsetY: true }"
          placeholder="Selecione"
          flat
          solo
          dense
          outlined
        ></v-select>
      </v-col> -->
      <v-col cols="12" sm="6" md="3" class="px-3 py-0">
        <label>Operadoras</label>
        <v-autocomplete
          v-model="formData.operadora_ans_id"
          :items="operadorasFilter"
          item-value="id"
          item-text="oper_nome"
          label="Selecione"
          multiple
          chips
          outlined
          flat
          solo
          dense
          filled
          :disabled="formData.carteira_id != null || operadorasFilter.length==1"
          :search-input.sync="searchInput"
        >
          <template v-slot:item="data">
            <v-list-item
              @click="toggleAutocomplete(data.item, 'operadora_ans_id')"
              :class="
                formData.operadora_ans_id.includes(data.item.id)
                  ? 'primary--text v-list-item--active'
                  : ''
              "
            >
              <v-list-item-content>
                <v-list-item-title>{{ data.item.oper_nome }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="data">
            <v-chip
              v-if="data.index < 2"
              small
              label
              class="ma-1"
              :style="
                formData.operadora_ans_id.length > 1
                  ? 'max-width:28%'
                  : 'max-width:90%'
              "
              >{{ data.item.oper_nome }}</v-chip
            >
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col class="py-0 px-3" cols="12" sm="6" md="3">
        <label>Status de validação</label>
        <v-select
          v-model="formData.login_valido"
          :items="statusFilter"
          item-value="id"
          item-text="descricao"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
        >
          <template v-slot:item="data">
            <template v-if="(typeof data.item !== 'object')">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title
                  v-html="data.item.descricao"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon
                  v-text="data.item.icon"
                  :color="data.item.color"
                  small
                ></v-icon>
              </v-list-item-icon>
            </template>
          </template>
        </v-select>
      </v-col>
      <v-col class="pb pt-5 px-2" cols="6" sm="3" md="1">
        <v-btn
          small
          max-width="100%"
          height="32px"
          color="primary"
          depressed
          class="px-5"
          @click="filterList(formData)"
          >Filtrar</v-btn
        >
      </v-col>
      <v-col class="pb-0 pt-5 px-3" cols="6" sm="3" md="2">
        <v-btn
          outlined
          small
          max-width="100%"
          height="32px"
          color="primary"
          depressed
          class="px-5"
          @click="clearFilters()"
          >Limpar Filtro</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        grupo_economico: null,
        prestador_id: [],
        operadora_ans_id: [],
        login_valido: null,
      },
      prestadoresFilter: [],
      operadorasFilter: [],
      statusFilter: [
        { id: null, descricao: "Selecione", color: null },
        {
          id: true,
          descricao: "Válido",
          color: "success",
          icon: "fa-check-circle",
        },
        {
          id: false,
          descricao: "Inválido",
          color: "error",
          icon: "fas fa-exclamation-circle",
        },
      ],
      searchInput: null
    };
  },
  watch: {
    formData: {
      deep: true,
      handler(val) {
        this.updateFilter(val)
      }
    },
    prestadores: {
      deep: true,
      handler(val) {
        this.prestadoresFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.prestador_id = [val[0].id];
        }
      },
    },
    operadoras: {
      deep: true,
      handler(val) {
        this.operadorasFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.operadora_ans_id = [val[0].id];
        } else if (this.formData.operadora_ans_id.length) {
          this.formData.operadora_ans_id =
            this.formData.operadora_ans_id.filter(
              (el) =>
                this.operadorasFilter.findIndex((item) => item.id == el) > -1
            );
        }
      },
    },
  },
  mounted() {
    let stateFilter = this.$store.state.recebiveis.identNaOperadoraFilter;
    this.formData.grupo_economico =
      this.$store.state.permissions.grupoEconomico;
    this.formData = stateFilter ? { ...stateFilter } : this.formData;
    this.filterList(this.formData);
  },
  methods: {
    clearFilters() {
      this.formData.prestador_id =
        this.prestadoresFilter.length == 1 ? this.formData.prestador_id : [];
      this.updateOperadoras();
      this.formData.operadora_ans_id =
        this.operadorasFilter.length == 1 ? this.formData.operadora_ans_id : [];
      this.formData.login_valido = null;

      this.filterList(this.formData);
    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null
      let index = this.formData[campo].indexOf(item.id);
      //  index > -1  está excluindo o item
      if (index > -1) {
        this.formData[campo].splice(index, 1);
      } else {
        //  index < 0  está adicionando o item
        this.formData[campo].push(item.id);
      }
      this.$nextTick();
      return;
    },
    updateOperadoras() {
      this.getOperadoras(this.formData.prestador_id);
    },
  },
  props: {
    filterData: Object,
    filterList: Function,
    getOperadoras: Function,
    operadoras: Array,
    prestadores: Array,
    updateFilter: Function
  },
}
</script>
